import styled from 'styled-components'

import { Alert } from '@syconium/little-miss-figgy'

import { NextLink } from '../../../../../../app/_components/navigation/NextLink'

export const LoginAlert = styled(Alert)`
  margin-bottom: ${o => o.theme.spacing(5)};
`

export const LoginMessage = styled(Alert.Message)`
  color: ${o => o.theme.color.stroke.info.text.on.subtle};
`
export const LoginLink = styled(NextLink)`
  text-decoration: underline;
`
